// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__7YgNF","siteName":"Header_siteName__V3y2v","nav":"Header_nav__3FYAJ","navItem":"Header_navItem__3yTw_","social":"Header_social__1VcBz"};